import React from 'react'
import ArrowDownRight from '../Icons/Arrow-down-right-sm'
import ArrowDownLeft from '../Icons/Arrow-down-left-sm'
import ArrowDown from '../Icons/Arrow-down'
import css from './index.css'

import { useNavigate, useParams } from 'react-router-dom';

export default function MerkleTree(props) {

    const navigate = useNavigate();

    let { clickable, userAnswer } = props;

    clickable = clickable || false;
    userAnswer = userAnswer || {};

    const goHash = (id) => {
        if (clickable) {
            // navigate(`/game2calculation/${id}`)
            props.setCurrHash(id);
        }
    }

    return (

        <div className="MerkleTreeDiagram">

            <div className='col-12'>
                <div className='row'>

                    <div className="col-3  ">
                        <div className="MerKleBoxGreen">
                            Data 1
                        </div>
                    </div>


                    <div className="col-3 ">
                        <div className="MerKleBoxGreen">
                            Data 2
                        </div>


                    </div>

                    <div className="col-3  ">
                        <div className="MerKleBoxGreen">
                            Data 3
                        </div>


                    </div>

                    <div className="col-3  ">
                        <div className="MerKleBoxGreen">
                            Data 4
                        </div>


                    </div>

                </div>
                <div className="col-12">
                    <div className="row">
                        <div className="col-3 MerKleBox">
                            {ArrowDown()}
                        </div>

                        <div className="col-3 MerKleBox">
                            {ArrowDown()}
                        </div>

                        <div className="col-3 MerKleBox">
                            {ArrowDown()}
                        </div>
                        <div className="col-3 MerKleBox">
                            {ArrowDown()}
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <div className="row">
                        <div className="col-3  ">
                            <div className={`MerKleBoxGreen ${clickable ? 'MerKleBoxClickableHover' : ''}`}
                                style={{ backgroundColor: userAnswer.b1 ? 'green' : null }}
                                onClick={() => { if (!userAnswer.b1) goHash(1) }}
                            >
                                Hash 1
                            </div>
                        </div>
                        <div className="col-3  ">
                            <div className={`MerKleBoxGreen ${clickable ? 'MerKleBoxClickableHover' : ''}`}
                                style={{ backgroundColor: userAnswer.b2 ? 'green' : null }}
                                onClick={() => { if (!userAnswer.b2) goHash(2) }}
                            >
                                Hash 2
                            </div>
                        </div>
                        <div className="col-3  ">
                            <div className={`MerKleBoxGreen ${clickable ? 'MerKleBoxClickableHover' : ''}`}
                                style={{ backgroundColor: userAnswer.b3 ? 'green' : null }}
                                onClick={() => { if (!userAnswer.b3) goHash(3) }}
                            >
                                Hash 3
                            </div>
                        </div>
                        <div className="col-3  ">
                            <div className={`MerKleBoxGreen ${clickable ? 'MerKleBoxClickableHover' : ''}`}
                                style={{ backgroundColor: userAnswer.b4 ? 'green' : null }}
                                onClick={() => { if (!userAnswer.b4) goHash(4) }}
                            >
                                Hash 4
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <div className="row">
                        <div className="col-3 MerKleBoxRight">
                            {ArrowDownRight()}
                        </div>

                        <div className="col-3 MerKleBoxLeft">
                            {ArrowDownLeft()}
                        </div>

                        <div className="col-3 MerKleBoxRight">
                            {ArrowDownRight()}
                        </div>
                        <div className="col-3 MerKleBoxLeft">
                            {ArrowDownLeft()}
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <div className="row">
                        <div className="col-6">
                            <div className={`MerKleBoxGreen2 ${clickable ? 'MerKleBoxClickableHover' : ''}`}
                                style={{
                                    backgroundColor: !clickable ? null : userAnswer.b1 && userAnswer.b2 ? userAnswer.b12 ? 'green' : null : 'lightgray',
                                }}
                                onClick={() => { if (userAnswer.b1 && userAnswer.b2 && !userAnswer.b12) { goHash(12) } }}
                            >
                                Hash 12
                            </div>
                        </div>
                        <div className="col-6  ">
                            <div className={`MerKleBoxGreen2 ${clickable ? 'MerKleBoxClickableHover' : ''}`}
                                style={{
                                    backgroundColor: !clickable ? null : userAnswer.b3 && userAnswer.b4 ? userAnswer.b34 ? 'green' : null : 'lightgray',
                                }}
                                onClick={() => { if (userAnswer.b3 && userAnswer.b4 && !userAnswer.b34) { goHash(34) } }}
                            >
                                Hash 34
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <div className="row">
                        <div className="col-6 MerKleBoxRight">
                            {ArrowDownRight()}
                        </div>
                        <div className="col-6 MerKleBoxLeft">
                            {ArrowDownLeft()}
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <div className="row">

                        <div className="col-12">
                            <div className={`MerKleBoxGreen3 ${clickable ? 'MerKleBoxClickableHover' : ''}`}
                                style={{
                                    backgroundColor: !clickable ? null : userAnswer.b12 && userAnswer.b34 ? userAnswer.b1234 ? 'green' : null : 'lightgray',
                                }}
                                onClick={() => { if (userAnswer.b12 && userAnswer.b34 && !userAnswer.b1234) { goHash(1234) } }}
                            >
                                Hash 1234
                            </div>
                        </div>
                    </div>
                </div>
            </div>






            {/* <div className="col-6">
                <div className="row">
                    <div className="col-4 MerKleBoxGreen">
                        Data 1
                    </div>
                    <div className="col-2 MerKleBox">
                        ——
                    </div>
                    <div className="col-4 MerKleBoxGreen" onClick={() => { goHash(1) }}>
                        Hash 1
                    </div>
                    <div className='col-2 arrowDownRight' >
                        {ArrowDownRight()}
                    </div>
                </div>
                <div className="row ">
                    <div className="col-4 MerKleBoxGreen">
                        Data 2
                    </div>
                    <div className="col-2 MerKleBox">
                        ——
                    </div>
                    <div className="col-4 MerKleBoxGreen" onClick={() => { goHash(2) }}>
                        Hash 2
                    </div>
                    <div className='col-2 arrowUpRight' >
                        {ArrowUpRight()}
                    </div>
                </div>
                <div className="row ">
                    <div className="col-4 MerKleBoxGreen">
                        Data 3
                    </div>
                    <div className="col-2 MerKleBox">
                        ——
                    </div>
                    <div className="col-4 MerKleBoxGreen" onClick={() => { goHash(3) }}>
                        Hash 3
                    </div>
                    <div className='col-2 arrowDownRight' >
                        {ArrowDownRight()}
                    </div>
                </div>
                <div className="row ">
                    <div className="col-4 MerKleBoxGreen">
                        Data 4
                    </div>
                    <div className="col-2 MerKleBox">
                        ——
                    </div>
                    <div className="col-4 MerKleBoxGreen" onClick={() => { goHash(4) }}>
                        Hash 4
                    </div>
                    <div className='col-2 arrowUpRight' >
                        {ArrowUpRight()}
                    </div>
                </div>

            </div>

            <div className="col-3 twoBox">
                <div className="row">
                    <div className="col-md-12 spaceBox" >

                    </div>

                </div>
                <div className="row">
                    <div className="col-md-12 MerKleBoxGreen" onClick={() => { goHash(12) }}>
                        Hash 12
                    </div>

                </div>
                <div className="row">
                    <div className="col-md-12 spaceBox " >

                    </div>

                </div>
                <div className="row">
                    <div className="col-md-12 MerKleBoxGreen" onClick={() => { goHash(34) }}>
                        Hash 34
                    </div>

                </div>




            </div>
            <div className="col-1 ">
                <div className="row">
                    <div className="col-md-12  " style={{ height: 70 }}>

                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 arrowDownRight"  >
                        {ArrowDownRight()}
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12  " style={{ height: 60 }}>

                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 arrowUpRight" >
                        {ArrowUpRight()}
                    </div>
                </div>
            </div>


            <div className="col-3 ">
                <div className="col-md-12 " style={{ height: 100 }}>

                </div>
                <div className="row">
                    <div className="col-md-12 MerKleBoxGreen" onClick={() => { goHash(1234) }}>
                        Hash 1234
                    </div>

                </div>
                <div className="col-md-12 " style={{ height: 100 }}>

                </div>
            </div>

 */}




        </div>

    )
}